export const routes = {
 
    fillRouteParams,

    files:{
        references: '/api/files/references/:referenceType/:objectId',
        folders: '/api/files/folders',
        filename: '/files/:privateFileName',
        uploadSlots: '/api/files/upload-slots'
    },
}

function fillRouteParams(template:string, params:{[key:string]: string}):string
{
    let route = template;
    for(const key in params){
        if(!route.includes(`:${key}`))
            throw new Error(`Missing parameter ${key} for route ${template}`);

        route = route.replace(`:${key}`, params[key]);
    }
    return route;
}